import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateExposureCompletion(
  patient: Patient | null | undefined,
) {
  const lifestyle = patient?.lifestyle;
  const exposures = lifestyle?.exposures;
  const exposureCount = Array.isArray(exposures) ? exposures.length : 0;

  // hasAnswer: true if hasExposures is explicitly set, OR if there are exposures (implies yes)
  const hasExplicitAnswer =
    lifestyle?.hasExposures !== undefined && lifestyle?.hasExposures !== null;
  const hasAnswer = hasExplicitAnswer || exposureCount > 0;

  // hasDetails: true if hasExposures is false (no details needed),
  // OR if there are actual exposures recorded
  const hasDetails = lifestyle?.hasExposures === false || exposureCount > 0;

  const total = 2;
  const completed = (hasAnswer ? 1 : 0) + (hasDetails ? 1 : 0);
  const percent = total > 0 ? completed / total : 0;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
